import { Injectable } from '@angular/core';
import { AccessDeniedService } from './access-denied.service';
import { CustomToastService } from '../pages/custom-toast/custom-toast.service';

@Injectable({
  providedIn: 'root',
})
export class OnAPIErrorService {
  constructor(
    private accessDeniedService: AccessDeniedService,
    private customToastService: CustomToastService,
  ) {}

  onAPIError(errorMessage: string, error) {
    if (!this.accessDeniedService.isAccessDenied(error)) {
      this.customToastService.error(errorMessage);
    }
  }
}
